import React from 'react'
import { Timeline } from '@material-ui/icons'
import { Form, Field } from 'formik'
import { IServerConfig } from '../../types/config'
import { dataStreamURIValidate } from './validation'
import { Button, CustomTextField } from '../../components'

interface IDataChartUrlForm {
  disabled?: boolean
  isValid?: boolean
  serverConfig: IServerConfig
}

export const DataChartUrlForm = ({
  isValid,
  disabled,
  serverConfig,
}: IDataChartUrlForm) => (
  <Form className="height-auto">
    <Field
      name="dataStreamURI"
      label="Add a Datastream Chart"
      placeholder="Paste URL"
      component={CustomTextField}
      endAdornment={<Timeline color={disabled ? 'disabled' : 'primary'} />}
      validate={dataStreamURIValidate(serverConfig.allowedDomains)}
      disabled={disabled}
    />
    <Button
      id="add-datastream-button"
      type="submit"
      variant="contained"
      color="primary"
      disabled={!isValid || disabled}
      fullWidth
    >
      Add DataStream
    </Button>
  </Form>
)
